import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../helpers';
import { Roles, SupervisionNoteStatus } from '../constants';

function useBtSupervisionEditable() {
  const { user } = useSelector((state: any) => state.auth);
  const { current: btSupervision } = useSelector((state: any) => state.btSupervision);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return;
    if (
      !areUserRolesIn(user?.roles, [Roles.Bcba]) ||
      !btSupervision ||
      !btSupervision.id ||
      btSupervision.status === SupervisionNoteStatus.Completed ||
      btSupervision.bcba?.email !== user?.email
    ) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [user, btSupervision]);

  return isEditable;
}

export default useBtSupervisionEditable;
